module.exports = __webpack_public_path__ + "files/6f5d4f4d842992c160d162785b963980.png";